<template>
  <div class="impact-indicator generic-border generic-border--tag generic-border--disabled">
    {{ displayedText }}
  </div>
</template>

<script>
/**
 * Impact indication about the value and what the value implies.
 * WARNING: After Shizen v2, The impact can be selected from 1 to 4, not 0 to 3.
 * But the database value will remain 0 to 3.
 *
 * @vue-prop {Number} value - Numerical value of the impact
 * @vue-prop {Boolean} [min] - Activate in to display only the numeric value
 */

export default {

  name: 'ImpactIndicator',

  props: {
    value: {
      type: Number,
      required: true,
    },
    min: Boolean,
  },

  data() {
    return {
      defaultIndications: {
        0: this.$t('message.IMPACT_LOW'),
        1: this.$t('message.IMPACT_MODERATE'),
        2: this.$t('message.IMPACT_SIGNIFICANT'),
        3: this.$t('message.IMPACT_CRITICAL'),
      },
    };
  },

  computed: {
    /** Number: Closest integer to the real value */
    displayedValue() {
      return Math.round(this.value);
    },
    /** String: Content of the component */
    displayedText() {
      if (this.min) {
        return this.displayedValue + 1;
      }
      return this.$t('message.IMPACT_DISPLAY', {
        val: this.displayedValue + 1,
        text: this.defaultIndications[`${this.displayedValue}`],
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.impact-indicator {
  border: solid 1px $color-shizen-blue;
  height: 2rem;
  border-radius: 2rem;
}
</style>
